import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/siteimages/logo.png";
import { Link, NavLink } from "react-router-dom";

import axios from "axios";

import { FaHome, FaSearch, FaShoppingCart } from "react-icons/fa"; // Importing search icon

Header5.propTypes = {};

function Header5({ clname = "", handleMobile }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleDropdown = (index) => {
    setActiveIndex(index);
  };

  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY > 100;
      if (scrollCheck !== scroll) {
        setScroll(scrollCheck);
      }
    });
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

  const [showSearch, setShowSearch] = useState(false);
  //  const [showCart, setShowCart] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    document.addEventListener("scroll", () => {
      setScroll(window.scrollY > 100);
    });
  }, []);

  const navigate = useNavigate();

const handleSearch = (e) => {
  e.preventDefault(); // ⛔ prevent page reload

  if (searchQuery.trim() !== "") {
    setShowSearch(false);
    navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
  }
};


  return (
    <header
      id="header"
      className={`header header-default ${scroll ? "is-fixed is-small" : ""}`}
    >
      <div className="tf-container ct2">
        <div className="row">
          <div className="col-md-12">
            <div className="sticky-area-wrap">
              <div className="header-ct-left">
                <div id="logo" className="logo">
                  <Link to="/home">
                    <img
                      className="site-logo"
                      id="trans-logo"
                      src={logo}
                      alt="Image"
                    />
                  </Link>
                </div>
              </div>
             <div className="header-ct-center">
                             <div className="nav-wrap">
                               <nav id="main-nav" className="main-nav">
                                 <ul id="menu-primary-menu" className={`menu ${clname}`}>
                                   <li className="menu-item">
                                     <Link to="/home"><FaHome size={20} /></Link>
                                   </li>
                                   {/* <li className="menu-item">
                                     <Link to="/about">About Us</Link>
                                   </li> */}
                                  
                 <li className="menu-item menu-item-has-children">
                   <Link to="#">eConsultation</Link>
                   <ul className="sub-menu st1">
                     {categoriesnew1.length > 0 ? (
                       categoriesnew1.map((categorynew1, index) => (
                         <li key={index} className="nav-sub subnav2">
                           <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
                         </li>
                       ))
                     ) : (
                       <li className="nav-sub subnav2">
                         <span>No categories available</span>
                       </li>
                     )}
                   </ul>
                 </li>
                                   
                                   <li className="menu-item menu-item-has-children">
                                     <Link to="#">eLearning</Link>
                                     <ul className="sub-menu st1">
                                       
                                       {categoriesnew2.length > 0 ? (
                                               categoriesnew2.map((categoriesnew2, index) => (
                                                 <li key={index} className="nav-sub subnav2">
                                                   <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
                                                 </li>
                                               ))
                                             ) : (
                                               <li className="nav-sub subnav2">
                                                 <span>No categories available</span>
                                               </li>
                                             )}
                                      
                                     </ul>
                                   </li>
                                  
                                   <li className="menu-item">
                                     <Link to="/epooja">ePooja</Link>
                                   </li>
                                    <li className="menu-item menu-item-has-children">
                   <Link to="#">Horoscope</Link>
                   <ul className="sub-menu st1">
                     {categoriesnew.length > 0 ? (
                       categoriesnew.map((categorynew, index) => (
                         <li key={index} className="nav-sub subnav2">
                           <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
                         </li>
                       ))
                     ) : (
                       <li className="nav-sub subnav2">
                         <span>No categories available</span>
                       </li>
                     )}
                   </ul>
                 </li>
                                  <li className="menu-item menu-item-has-children">
                   <Link to="#">Blog</Link>
                   <ul className="sub-menu st1">
                     {categories.length > 0 ? (
                       categories.map((categories, index) => (
                         <li key={index} className="nav-sub subnav2">
                           <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
                         </li>
                       ))
                     ) : (
                       <li className="nav-sub subnav2">
                         <span>No categories available</span>
                       </li>
                     )}
                   </ul>
                 </li>
                  <li className="menu-item">
                                     <Link to="/support">Support</Link>
                                   </li>
                                  
                                   
                                 </ul>
                               </nav>
                             </div>
                           </div>
              <div className="header-ct-right">
              <div className="search-icon" style={{ cursor: "pointer", marginRight: "20px" }}
                  onClick={() => setShowSearch(!showSearch)}>
                  <FaSearch size={20} />
                </div>
               
                {showSearch && (
  <div
    className="search-box"
    style={{
      position: "absolute",
      top: "80px",
      background: "white",
      padding: "10px",
      borderRadius: "5px",
      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
      zIndex: 99999,
      width: "100%",
      right: "0px",
      maxWidth: "450px",
      marginTop: "10px"
    }}
  >
    <form onSubmit={handleSearch}>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td style={{ width: "90%" }}>
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search By Keywords.."
                style={{
                  fontWeight: "bold",
                  color: "black",
                  borderColor: "#f2f2f2",
                  borderRadius: "4px",
                  backgroundColor: "#f2f2f2",
                  width: "100%"
                }}
              />
            </td>
            <td style={{ width: "10%" }}>
              <button
                type="submit"
                style={{
                  padding: "11px 32px",
                  backgroundColor: "#14a077",
                  borderRadius: "4px",
                  fontWeight: "700",
                  fontSize: "16px",
                  lineHeight: "26px",
                  color: "#ffffff",
                  border: "none",
                  width: "100%"
                }}
              >
                Go
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
)}
                {/* {showCart && (
                  <div className="search-box" style={{ position: "absolute", top: "80px", background: "white", padding: "10px", borderRadius: "5px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)", zIndex:99999, right:"0px", width:"350px", height:"250px", textAlign:"center", backgroundColor:"#f2f2f2" }}>
                    
                    <h6 style={{paddingTop:"35px"}}>Minicart</h6>
                    <p style={{maxWidth:"250px", padding:"auto", margin:"auto"}}>Future Implementation of mincart feature invoked by automatic Ecommerce Cart items import. Requires product listings to take effect.</p>
                  </div>
                )} */}
              <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    color: "#ffffff",
    borderColor: "transparent",
    textTransform: "capitalize", marginRight:"6px"}}>
                  <Link to="/astrologerdashboard" style={{color: "#ffffff"}}>Dashboard</Link>
                </div>
              </div>
              <div className="nav-filter" onClick={handleMobile}>
                <div className="nav-mobile">
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header5;
